<app-input-wrapper
  [label]="label"
  [label2]="label2"
  [labelOnPress]="labelOnPress"
  [valueLabel]="valueLabel"
  [required]="required"
  [errorMessage]="errorMessage"
  [touched]="touched"
  [alt]="alt"
  [onPress]="onPress"
  [disabled]="disabled ?? false"
  [readonly]="readonly ?? false"
  [leftIcon]="leftIcon"
  [rightIcon]="rightIcon"
>

  <!-- PrimeNG Dropdown for Select Input -->
  <p-dropdown
    [styleClass]="'full-width-dropdown'"
    [options]="options"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    [disabled]="disabled ?? false"
    [readonly]="readonly ?? false"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    (onChange)="handleSelectChange($event)"
    [filter]="filter"
    [appendTo]="'body'"
  >
  </p-dropdown>

</app-input-wrapper>
